export { default } from './OpenFinance';



// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/OpenFinance/index.jsx